module.exports = __webpack_public_path__ + "img/pic-logo-bl.1fe618e0.png";